module.exports = __webpack_public_path__ + "static/media/injection.a60a7ba8.png";